import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';

/* Stale-chunk recovery. Vite code-splits heavy modules (mermaid,
 * cytoscape, katex, …) into hashed chunks. When we deploy a new
 * build, the old hashes disappear from the CDN. A browser that
 * cached the previous index.html (especially PWAs / iOS Safari
 * with aggressive HTML caching) would try to load a now-missing
 * chunk and fail with "error loading dynamically imported module".
 *
 * Vite emits `vite:preloadError` on every failed chunk load. We
 * catch it once and hard-reload the page — the next request gets
 * the fresh index.html with the new hashes. Guard against an
 * infinite loop by stamping a session key. */
if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', () => {
    const key = 'erasphere.preload-reload-at';
    const now = Date.now();
    let last = 0;
    try { last = Number(sessionStorage.getItem(key) || '0'); } catch {}
    // Only auto-reload once per minute so a chronically broken
    // chunk doesn't spin the browser forever.
    if (now - last > 60_000) {
      try { sessionStorage.setItem(key, String(now)); } catch {}
      window.location.reload();
    }
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);
